import type { DocPageContent } from '../docs-content'

const page = {
  order: 14,
  slug: 'transitions',
  title: 'Transiciones',
  description:
    'Aplica una transición a un corte y ajusta su estilo, duración, ubicación, easing y dirección.',
  category: 'Herramientas Creativas',
  related: ['timeline', 'effects-color'],
  sections: [
    {
      title: 'Aplicar una transición',
      blocks: [
        {
          kind: 'steps',
          items: [
            'Abre la pestaña **Transiciones** en la barra lateral de medios.',
            'Arrastra una tarjeta de transición a un corte entre dos clips adyacentes — o selecciona un corte válido y haz clic en una tarjeta.',
            'Selecciona la transición en la línea de tiempo para abrir la sección **Transición** en Propiedades.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Un corte es válido cuando dos clips están uno al lado del otro con suficientes fotogramas de origen sobrantes para superponerse. Aplicar sobre una transición existente la reemplaza en su lugar.',
        },
      ],
    },
    {
      title: 'Elegir un aspecto',
      blocks: [
        {
          kind: 'paragraph',
          text: 'Las tarjetas se agrupan por categoría: **Básico**, **Disolución**, **Movimiento**, **Barrido**, **Deslizamiento**, **Giro**, **Máscara**, **Iris**, **Forma**, **Luz** y **Cromática**.',
        },
        {
          kind: 'list',
          items: [
            'Los estilos de disolución van desde una simple Disolución Cruzada hasta variantes Aditiva, Desenfoque y Disolución a Color.',
            'Los estilos de movimiento y personalizados incluyen Giro, Fuga de Luz, Pixelado, Cromática, Desenfoque Radial, Glitch y Destellos.',
            'Los estilos direccionales como Barrido, Deslizamiento y Giro aparecen como varias tarjetas, una por dirección.',
          ],
        },
      ],
    },
    {
      title: 'Ajustar una transición',
      blocks: [
        {
          kind: 'table',
          headers: ['Control', 'Qué hace'],
          rows: [
            ['Preajuste', 'Cambia el estilo de transición sin rehacer el corte.'],
            ['Duración', 'Establece la duración de la transición; restablecer la devuelve a 1 segundo.'],
            ['Ubicación', 'Centra en el corte, o desplaza la transición antes o después de él.'],
            ['Easing', 'Lineal, Entrada, Salida, o Entrada y Salida.'],
            ['Dirección', 'Izquierda, Derecha, Arriba o Abajo, para estilos direccionales.'],
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: 'También puedes redimensionar una transición arrastrando su borde directamente en la línea de tiempo.',
        },
      ],
    },
    {
      title: 'Cuándo no se aplicará una transición',
      blocks: [
        {
          kind: 'note',
          tone: 'warning',
          text: 'Necesitas un corte real entre dos clips y suficiente **material de origen** en el lado correspondiente. Si una ubicación está bloqueada, elige otra ubicación o recorta menos. Arrastrar sobre un corte válido siempre funciona, incluso cuando hacer clic para aplicar no está disponible.',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page